<div class="full-screen-bg">
	<div *ngIf="loadershow" class="loader text-center">
		<img src="../assets/img/loading.gif" />
	</div>
	<div class="container container-sm">
		<div class="row">
			<div class="col"></div>
			<div class="col-6 rounded my-5 form-bg">
				<div class="row">
					<div class="col text-center my-4">
						<img src="../assets/img/3Cube-White.png" alt="Image" width="130px" />
					</div>
				</div>
				<div class="row px-3">
					<div class="col">
						<form role="form" (ngSubmit)="submitForm(user)">
							<div class="row mt-2">
								<div class="col">
									<p class="fw-bold text-light">
										Please enter your registered email address:
									</p>
								</div>
							</div>
							<div class="row mt-2">
								<div class="col">
									<div class="input-group mb-3">
										<span class="input-group-text" id="basic-addon1"><fa-icon
												[icon]="['fas', 'envelope']"></fa-icon></span>
										<input type="text" class="form-control" placeholder="Email-Id"
											[(ngModel)]="user.email" [ngModelOptions]="{standalone: true}">
									</div>
								</div>
							</div>
							<div class="row mt-2">
								<div class="col text-center">
									<button id="btnSubmit" type="submit" class="btn btn-success w-100">
										Send
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col-sm-12 text-center text-light fw-bold mt-1">
						&nbsp;&copy; {{year}}&nbsp;
						<a href="http://3cubeservices.com/" target="_blank" class="text-light">
							3CUBE
						</a>
					</div>
				</div>
				<div class="row my-1">
					<div class="col mt-2" *ngIf="errorshow || successshow">
						<div *ngIf="errorshow" role="alert" type="danger" class="alert alert-danger text-center">
							<div class="text-center">
								<span class="ng-binding ng-scope">{{errorMsg}}</span>
							</div>
						</div>
						<div *ngIf="successshow" role="alert" type="danger" class="alert alert-info text-center">
							<div class="text-center">
								<span class="ng-binding ng-scope">{{successMsg}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col"></div>
		</div>
	</div>
</div>